import { DateTime } from 'luxon';

import { DASH } from '@/globals';
import Validatable from '@/validator/Validatable';

import Role, { IRoleApi } from './Role';
import User, { IUserApi } from './User';

export interface IUserOrganization {
  createdOnUtc: string;
  id: number;
  modifiedOnUtc: string;
  organizationID: number;
  role: Role;
  roleID: number;
  user: User;
  userID: number;
}

export interface IUserOrganizationApi {
  created_on_utc?: string;
  modified_on_utc?: string;
  organization_id: number;
  role?: IRoleApi;
  role_id: number;
  user?: IUserApi;
  user_id: number;
  user_organization_id: number;
}

export default class UserOrganization extends Validatable {
  organizationID: number;

  roleID: number;

  role: Role;

  userID: number;

  user: User;

  createdOnUtc: string;

  modifiedOnUtc: string;

  constructor(
    id = -1,
    organizationID: number,
    roleID: number,
    role: Role,
    userID: number,
    user: User,
    createdOnUtc: string = null,
    modifiedOnUtc: string = null,
  ) {
    super();
    this.id = id;
    this.organizationID = organizationID;
    this.roleID = roleID;
    this.role = role;
    this.userID = userID;
    this.user = user;
    this.createdOnUtc = createdOnUtc;
    this.modifiedOnUtc = modifiedOnUtc;
  }

  get email(): string {
    return this.user.email;
  }

  get roleCode(): string {
    return this.role.readableCode;
  }

  get isActivated(): boolean {
    return this.user?.isActivated;
  }

  get isActivatedDescription(): string {
    return this.user.isActivatedDescription;
  }

  get lastLoginFormatted(): string {
    return this.user.lastLoginFormatted;
  }

  get createdOnUtcFormatted(): string {
    return this.createdOnUtc != null
      ? DateTime.fromISO(this.createdOnUtc, { zone: 'utc' }).toLocal().toLocaleString(DateTime.DATETIME_MED)
      : DASH;
  }

  static fromApi(apiObject: IUserOrganizationApi): UserOrganization {
    return new UserOrganization(
      apiObject.user_organization_id,
      apiObject.organization_id,
      apiObject.role_id,
      apiObject.role ? Role.fromApi(apiObject.role) : null,
      apiObject.user_id,
      apiObject.user ? User.fromApi(apiObject.user) : null,
      apiObject.created_on_utc,
      apiObject.modified_on_utc,
    );
  }

  static fromObject(obj: IUserOrganization): UserOrganization {
    return super.fromObject(obj, new UserOrganization());
  }

  toApi(): IUserOrganizationApi {
    return {
      user_organization_id: this.id,
      organization_id: this.organizationID,
      role_id: this.roleID,
      user_id: this.userID,
    };
  }
}
